import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Pipe({
  name: 'getFormControls',
})
export class GetFormControlsPipe implements PipeTransform {
  transform(value: FormGroup, arg1: any, ...args: any[]): any {
    let forms = value.get(arg1) as FormArray;
    return forms.controls;
  }
}
